import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { TodoListTrackerIcon } from 'BreetAssets';
import { capitalizeFirstLetters } from 'BreetHelpers';

import type { IDialogTodoListItem } from './DialogTodolist.helpers';

const DialogTodoListItem = ({ header, status, subHeader, onClick, isLast }: IDialogTodoListItem) => (
	<div className='todo-list-item'>
		<div className='todo-list-left'>
			<div className='progress-tracker'>
				<TodoListTrackerIcon status={status} />

				{!isLast && <div className={classNameMerger('progress-tracker-tail', status)} />}
			</div>

			<div className='todo-list-item-txt'>
				<Typography as='h6'>{header}</Typography>
				<Typography>{subHeader}</Typography>
			</div>
		</div>

		<Button
			className={classNameMerger('todo-list-item-status', status)}
			onClick={status === 'get-started' ? onClick : undefined}
			variant='native'
		>
			{capitalizeFirstLetters(status)}
		</Button>
	</div>
);

export default DialogTodoListItem;
